<template>
  <div class="login">
    <div v-if="accountLogin">
      <van-cell-group>
        <van-field v-model="userName" placeholder="请输入用户名" />
        <van-field v-model="pwd" type="password" placeholder="请输入密码" />
      </van-cell-group>
      <van-button type="primary" v-on:click="login">账号登录</van-button>

      <div class="reg">
        <router-link to="/Reg">立即注册</router-link>| 忘记密码
      </div>
    </div>
    <div class="qitaLogin">
      <van-divider>微信登录</van-divider>
      <a
        :href="'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxb357668754d64908&redirect_uri=http://yijia.sihandbms.cn/api.php/s_weixin/Login/login/share/'+shareId+'&response_type=code&scope=snsapi_userinfo&state='+redirect+'#wechat_redirect'"
      >
        <img src="../../assets/weixin.png" />
      </a>
    </div>
    <div style="position:fixed; bottom:0;  width:100%; height:5rem" v-on:click="accountLoginShow()"></div>
    <div class="zz" v-if="agree!=1">
      <div class="content">
        <div class="detail" v-html="detail.post_content"></div>
        <div class="agree">
          <div v-on:click="agreeNoClick()">不同意</div>
          <div v-on:click="agreeClick()">同意</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Field, Cell, CellGroup, Divider } from "vant";

Vue.use(Cell)
  .use(CellGroup)
  .use(Divider);
Vue.use(Field);
import { Button } from "vant";

Vue.use(Button);
export default {
  name: "login",
  data() {
    return {
      shareId: 0,
      userName: "admin",
      pwd: "",
      user: {},
      accountLogin: false,
      clickNum: 0,
      detail: {},
      agree: 1,
      redirect: this.$route.query.redirect
    };
  },

  methods: {
    accountLoginShow() {
      this.clickNum++;
      if (this.clickNum > 5) {
        this.accountLogin = true;
      }
    },
    agreeClick() {
      localStorage.setItem("agree", 1);
      this.agree = 1;
    },
    agreeNoClick() {
      this.$router.go(-1);
    },
    login() {
      this.$http
        .post(this.GLOBAL.API + "user/public/login", {
          username: this.userName,
          password: this.pwd,
          device_type: "mobile"
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            if (this.user) {
              localStorage.setItem("user", JSON.stringify(data.data));
              this.$toast("登录成功");
              this.$router.go(-1);
            }
          } else {
            this.$toast(data.msg);
          }
        });
    },
    getData() {
      this.$http
        .get(this.GLOBAL.API + "portal/Portal/portal_post_detail?post_id=66", {
          params: {},
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.detail = data.data;
            this.detail.post_content = this.detail.post_content.replace(
              /src="default/g,
              'src="' + this.GLOBAL.IMG + "default"
            );
          } else {
            this.$toast(data.msg);
          }
        });
    }
  },
  mounted() {
    let share = localStorage.getItem("share");
    if (share) {
      this.shareId = share;
    }
    this.agree = localStorage.getItem("agree");
    if (this.agree != 1) {
      this.getData();
    }
  }
};
</script>
<style lang="scss" scoped>
.login {
  background-color: #fff;
  .zz {
    width: 100%;
    height: 100%;
    background-color: #000000;
    opacity: 0.6;
    position: absolute;
    top: 0;
    z-index: 999;
    .content {
      width: 80%;
      height: 80%;

      background-color: #fff;
      margin: 0 auto;
      top: 50%;
      position: relative;
      transform: translateY(-50%);
      font-size: 2rem;
      .detail {
        height: 90%;
        position: relative;
        overflow: scroll;
        color: #000000;
        text-align: left;
        padding: 1rem;
        a {
          color: #e4811d;
        }
      }
      .agree {
        padding: 1rem;
        width: 100%;
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: flex-end;
        color: #e4811d;
        div {
          padding: 1rem;
        }
      }
    }
  }
}
.qitaLogin {
  padding-top: 3rem;
  text-align: center;
  div {
    display: flex;
    text-align: center;
    padding: 0.2rem;
    color: #b2b2b2;
    width: 100%;
  }
  a {
    img {
      width: 4rem;
      height: 4rem;
      margin-top: 2rem;
    }
  }
}
</style>